<template>
    <div>
        <LoadingSpinner v-if="isLoading" message="Loading data..." />
        <div v-else>
      

            <div id="page-wrapper">
        
            
            
                <!-- Header -->
                <section id="header" class="wrapper">  </section>
            
                <div id="main" class="wrapper style2">

                    <div class="container">

                        <div id="content">

                            <article class="box post">

                                <header class="style1">

                                    <h2>{{ $t('customerSurvey') }}</h2>
                                    
                                </header>

                                <form @submit.prevent="submitData" method="POST">

                                    <div class="row gtr-50">

                                        <div class="col-12">
                                                            
                                            <label class="form-label">{{ $t("language") }}</label>
                                        
                                            <select
                                            @change="langChanged(selectedLang)"
                                            v-model="selectedLang"
                                            >
                                            <option
                                                v-for="(lang, i) in langs"
                                                :key="`Lang${i}`"
                                                :value="lang.value"
                                            >
                                                <font style="color: #212529">{{ lang.name }}</font>
                                            </option>
                                            </select>
                                            

                                        </div>


                                        <div class="col-6 col-12-small">
                                            <label class="form-label">{{ $t("name") }}</label>
                                            <input type="text" v-model="forms.customer_name" readonly />
                                        </div>


                                        <div class="col-6 col-12-small">
                                            <label class="form-label">{{ $t("departement") }} <span style="color:red;">*</span> </label>
                                            <input type="text" v-model="forms.customer_departement" required maxlength="255" :class="{ 'is-invalid': errors.customer_departement }" />
                                            <div v-if="errors.customer_departement">
                                                <div class="alert alert-primary" role="alert">
                                                    <i data-feather="alert-circle"></i>
                                                    {{ errors.customer_departement[0] }}
                                                </div>
                                            </div>

                                        </div>


                                        <div class="col-6 col-12-small">
                                            <label class="form-label">{{ $t("email") }}</label>
                                            <input type="email" v-model="forms.customer_email" readonly />
                                        </div>


                                        <div class="col-6 col-12-small">
                                            <label class="form-label">{{ $t("companyName") }}</label>
                                            <input type="text" v-model="forms.customer_company" readonly />
                                        </div>


                                        <div class="col-12">
                                            <label for="exampleInputEmail1" class="form-label">{{ $t("layanan") }} <span style="color:red;">*</span> </label>

                                             <div v-if="errors.layanan">
                                                <div class="alert alert-primary" role="alert">
                                                    <i data-feather="alert-circle"></i>
                                                    {{ errors.layanan[0] }}
                                                </div>
                                            </div>

                                            <div v-if="forms.linc_logistics" class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" v-model="forms.linc_logistics">
                                                <label class="form-check-label" for="flexSwitchCheckDefault">Linc Logistics - Warehousing & Distribution Center</label>
                                            </div>
                                            <div v-else class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" v-model="forms.linc_logistics" checked>
                                                <label class="form-check-label" for="flexSwitchCheckDefault">Linc Logistics - Warehousing & Distribution Center</label>
                                            </div>

                                            <div v-if="forms.linc_express" class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" v-model="forms.linc_express">
                                                <label class="form-check-label" for="flexSwitchCheckDefault">Linc Express - Transportation (Package & Bulk)</label>
                                            </div>
                                            <div v-else class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" v-model="forms.linc_express" checked>
                                                <label class="form-check-label" for="flexSwitchCheckDefault">Linc Express - Transportation (Package & Bulk)</label>
                                            </div>
                                            
                                            <div v-if="forms.linc_impex" class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" v-model="forms.linc_impex">
                                                <label class="form-check-label" for="flexSwitchCheckDefault">Linc Impex - Freight Forwarding & Customs Brokerage</label>
                                            </div>
                                            <div v-else class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" v-model="forms.linc_impex" checked>
                                                <label class="form-check-label" for="flexSwitchCheckDefault">Linc Impex - Freight Forwarding & Customs Brokerage</label>
                                            </div>
                                            
                                            <div v-if="forms.linc_terminal" class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" v-model="forms.linc_terminal">
                                                <label class="form-check-label" for="flexSwitchCheckDefault">Linc Terminal - Tank Farm Storage & Liquid Handling</label>
                                            </div>
                                            <div v-else class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" v-model="forms.linc_terminal" checked>
                                                <label class="form-check-label" for="flexSwitchCheckDefault">Linc Terminal - Tank Farm Storage & Liquid Handling</label>
                                            </div>

                                        </div>



                                        <div class="col-12">
                                            <ul class="actions">
                                                <li><input type="submit" class="style1" :value="$t('nextPage')" /></li>
                                            </ul>
                                        </div>

                                    </div>


                                </form>



                            </article>

                        </div>

                    </div>

                </div>


            </div>
            

        </div>
    </div>


</template>


<script>

import LoadingSpinner from './LoadingSpinner.vue';

export default {

    name: "MainPage",
    components: {
        LoadingSpinner,
    },

    props: {

        locales: String,

    },

    data() {
    return {
        isLoading:true,
        errors:[],
        forms: {
            customer_name:"",
            customer_departement:"",
            customer_email:"",
            customer_company:"",
            years:"",
            linc_logistics:0,
            linc_express:0,
            linc_impex:0,
            linc_terminal:0,
            merekomendasikan_linc:1,
            kesan_dengan_linc:"",
            hal_yang_perlu_ditingkatkan:"",
        },
        detailsForm:[],
        langs: [
            {
            name:"Indonesia",
            value:"id"
            },
            {
            name:"English",
            value:"en"
            }
        ],
        selectedLang: "",
        locale: "",
    };
    },

    computed: {
    
    },

    watch: {
        
        locales: {
            handler(newVal) {
                this.selectedLang = newVal;
            },
            immediate: true,
            deep: true,
        },

    },

    methods: {

        langChanged(lang) {
            this.locale       = lang;
            this.$i18n.locale = lang;
            localStorage.Lang = lang;
        },

        submitData(){
            this.errors = [];

            this.$swal({
                title: this.$t("areYouSure"),
                text: '',
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                
                if (result.value) {

                    this.isLoading  = true;

                    var customer_departement = this.forms.customer_departement;

                    if (customer_departement === '' || customer_departement === null || typeof customer_departement === 'undefined') {

                        this.errors.customer_departement = [ this.$t("customer_departementWajibIsi") ];
                        
                        this.error( this.$t("customer_departementWajibIsi") );
                        
                    }

                    if (this.forms.linc_logistics === 0 && this.forms.linc_express === 0 && this.forms.linc_impex === 0 && this.forms.linc_terminal === 0) {

                        this.errors.layanan = [ this.$t("validationLayanan") ];
                        
                        this.error( this.$t("validationLayanan") );

                    }
 

                    var details = [];
                     
                    localStorage.setItem("questionId", this.$route.params.id);
                    let dummy = JSON.stringify(this.forms);
                    let dummyDetails = JSON.stringify(details);
                    localStorage.setItem("formDataHeader", dummy);
                    localStorage.setItem("formDataDetails", dummyDetails);

                    if (this.forms.linc_logistics) {

                        window.location.href = '/survey-linc-logistics/' + this.$route.params.id;

                    }else{

                        if (this.forms.linc_express) {

                            window.location.href = '/survey-linc-express/' + this.$route.params.id;

                        }else{

                            if (this.forms.linc_impex) {

                                window.location.href = '/survey-linc-impex/' + this.$route.params.id;

                            }else{

                                if (this.forms.linc_terminal) {

                                    window.location.href = '/survey-linc-terminal/' + this.$route.params.id;

                                }
                            }

                        }

                    }
                     

                    this.isLoading  = false;


                }

            });

        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                this.error(objectData[y]);
                }
            }
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        loadData() {
            
            const baseURI = this.$settings.endPointCeisa + "v1/survey-2025/detail-data/" + this.$route.params.id;
            return this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
                this.isLoading = false;
                let res = response.data.datas;
                if(res === null){
                    this.$router.push('/not-found');
                }
                if (res.status == "DONE") {
                    this.$router.push("/done");
                } else {
                    this.forms = res;
                }
            }).catch((error) => {
                this.isLoading = false;
                if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
                } else {
                    if (error.response) {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                        this.logout();
                    } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                        this.$router.push("/server-error");
                    } else {
                        this.$router.push("/page-not-found");
                    }
                    }
                }
            });
        },
    

    },


    events: {

    },

    created: function () {
    
    },

    mounted() {
        
        this.langChanged(this.$i18n.locale);
        this.selectedLang = this.$i18n.locale;
        this.loadData(); 

    },

    updated() {


    },

    onLoad(){


    }


}
</script>

<style scoped>

</style>